import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function VideoGrid() {
  const displayArticles = articles.filter((a) => a.isHot || a.isNew).slice(0, 4);

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          <a href="#hot-videos" className="hover:text-primary-600 transition-colors">🔥 热门黑料视频</a>
        </h2>
        <p className="mt-3 text-foreground-500 text-sm md:text-base">实时追踪最新爆料，精彩内容不容错过</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6" data-product-shop="">
        {displayArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-accent-300/60 transition-all duration-300"
          >
            <div className="relative">
              {article.isHot && (
                <span className="absolute top-3 left-3 z-10 px-2.5 py-1 bg-primary-500 text-white text-xs font-semibold rounded-full whitespace-nowrap">
                  热门
                </span>
              )}
              {article.isNew && !article.isHot && (
                <span className="absolute top-3 left-3 z-10 px-2.5 py-1 bg-accent-500 text-white text-xs font-semibold rounded-full whitespace-nowrap">
                  最新
                </span>
              )}
              <div className="aspect-video overflow-hidden bg-background-200">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`${article.title} - 黑料视频在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                <span className="opacity-0 group-hover:opacity-100 transition-opacity w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-600">
                  <i className="ri-play-fill text-xl"></i>
                </span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                {article.title}
              </h3>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-eye-line text-xs"></i>
                  </span>
                  {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                </span>
                <span className="flex items-center gap-1">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-time-line text-xs"></i>
                  </span>
                  {article.date}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}